import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, Observable, of, switchMap, take } from 'rxjs';

import { selectSessionUser } from 'src/app/auth/store/session/session.selectors';
import { AuthService } from '../services/auth.service';
import { SessionActions } from 'src/app/auth/store/session/session.actions';

@Injectable({
  providedIn: 'root'
})
export class NonAuthenticatedGuardService {
  constructor(private store: Store, private router: Router, private authService: AuthService) {}
  canActivate(): Observable<boolean> {
    return this.store.select(selectSessionUser).pipe(
      switchMap(user => {
        if (user === null) {
          return this.authService.getUser().pipe(
            take(1),
            map(user => {
              this.store.dispatch(SessionActions.get_user_success({ user }));
              this.router.navigate(['/projects']);
              return false;
            }),
            catchError(error => {
              if (error.status === 401) {
                return of(true);
              } else {
                // TODO (global error handling): navigate to general error page
                return of(true);
              }
            })
          );
        } else {
          return of(false);
        }
      })
    );
  }
}

export const NonAuthenticatedGuard: CanActivateFn = () => {
  return inject(NonAuthenticatedGuardService).canActivate();
};
